import React from 'react';
import ReCAPTCHA from 'react-recaptcha';
import PropTypes from 'prop-types';
import loadjs from 'loadjs';

import { recaptchaScript } from '../../constants/lq-constants';
import { updateRecaptchaResponse } from '../loop-qual-app/actions';

class ReCaptcha extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      gMapApiLoaded: false,
    };
  }

  componentDidMount() {
    if (!window.recaptcha) {
      loadjs(recaptchaScript(), { returnPromise: true })
        .then(() => {
          this.setState({ gMapApiLoaded: true });
        })
        .catch(() => {
          console.warn(new Error('Failed to load google ma api'));
        });
    } else {
      this.setState({ gMapApiLoaded: true });
    }
  }

  callback = () => {};

  handleCaptchaResolution = (value) => {
    if (value) {
      this.props.dispatch(updateRecaptchaResponse(value));
    } else {
      this.recaptchaInstance.reset();
    }
    // logPageDetailsInfo(PAGEACTIVITY.PAGE.LQ2, 'onCaptcheComplete', PAGEACTIVITY.MSG.onCaptcheComplete, PAGEACTIVITY.UA);
  };

  render() {
    const { siteKey } = this.props;
    // this.props.siteKey
    return (
      <>
        {this.props.reCaptchaEnabled && this.state.gMapApiLoaded && (
          <ReCAPTCHA
            ref={(e) => {
              this.recaptchaInstance = e;
            }}
            sitekey={siteKey}
            render="explicit"
            verifyCallback={this.handleCaptchaResolution}
            // onChange={this.props.onChange}
            onloadCallback={this.callback}
          />
        )}
      </>
    );
  }
}

ReCaptcha.propTypes = {
  siteKey: PropTypes.string.isRequired,
  // onChange: PropTypes.func.isRequired,
  reCaptchaEnabled: PropTypes.any,
  dispatch: PropTypes.any,
};

export default ReCaptcha;
